import * as logout from './reducers/logout';
import * as login from './reducers/login';
import * as signup from './reducers/signup';
import * as forgot from './reducers/forgot';
import * as cancelWithdrawal from './reducers/cancel-withdrawal';
import * as changePassword from './reducers/change-password';
import * as changeAddress from './reducers/change-address';
import * as changeContactNumber from './reducers/change-contact-number';
import * as changeEmail from './reducers/change-email';
import * as resetPassword from './reducers/reset-password';
import * as getTransactions from './reducers/get-transactions';
import * as universeSwitch from './reducers/switch-univers';

import { update } from './reducers/update';
import { clear } from './reducers/clear';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    USER_DATA: update,
    USER_CLEAR: clear,

    USER_LOGOUT_REQUEST: logout.request,
    USER_LOGOUT_FINISH: logout.finish,

    USER_LOGIN_REQUEST: login.request,
    USER_LOGIN_FINISH: login.finish,
    USER_LOGIN_ERROR: login.error,
    USER_LOGIN_CLEAR: login.clear,

    USER_SIGNUP_REQUEST: signup.request,
    USER_SIGNUP_FINISH: signup.finish,
    USER_SIGNUP_ERROR: signup.error,
    USER_SIGNUP_CLEAR: signup.clear,

    USER_FORGOT_REQUEST: forgot.request,
    USER_FORGOT_FINISH: forgot.finish,
    USER_FORGOT_ERROR: forgot.error,
    USER_FORGOT_CLEAR: forgot.clear,

    USER_CANCEL_WITHDRAWAL_REQUEST: cancelWithdrawal.request,
    USER_CANCEL_WITHDRAWAL_FINISH: cancelWithdrawal.finish,
    USER_CANCEL_WITHDRAWAL_ERROR: cancelWithdrawal.error,
    USER_CANCEL_WITHDRAWAL_CLEAR: cancelWithdrawal.clear,

    USER_CHANGE_PASSWORD_REQUEST: changePassword.request,
    USER_CHANGE_PASSWORD_FINISH: changePassword.finish,
    USER_CHANGE_PASSWORD_ERROR: changePassword.error,
    USER_CHANGE_PASSWORD_CLEAR: changePassword.clear,

    USER_CHANGE_ADDRESS_REQUEST: changeAddress.request,
    USER_CHANGE_ADDRESS_FINISH: changeAddress.finish,
    USER_CHANGE_ADDRESS_ERROR: changeAddress.error,
    USER_CHANGE_ADDRESS_CLEAR: changeAddress.clear,

    USER_CHANGE_EMAIL_REQUEST: changeEmail.request,
    USER_CHANGE_EMAIL_FINISH: changeEmail.finish,
    USER_CHANGE_EMAIL_ERROR: changeEmail.error,
    USER_CHANGE_EMAIL_CLEAR: changeEmail.clear,

    USER_CHANGE_CONTACT_NUMBER_REQUEST: changeContactNumber.request,
    USER_CHANGE_CONTACT_NUMBER_FINISH: changeContactNumber.finish,
    USER_CHANGE_CONTACT_NUMBER_ERROR: changeContactNumber.error,
    USER_CHANGE_CONTACT_NUMBER_CLEAR: changeContactNumber.clear,

    USER_RESET_PASSWORD_REQUEST: resetPassword.request,
    USER_RESET_PASSWORD_FINISH: resetPassword.finish,
    USER_RESET_PASSWORD_ERROR: resetPassword.error,
    USER_RESET_PASSWORD_CLEAR: resetPassword.clear,

    USER_GET_TRANSACTIONS_REQUEST: getTransactions.request,
    USER_GET_TRANSACTIONS_FINISH: getTransactions.finish,
    USER_GET_TRANSACTIONS_ERROR: getTransactions.error,
    USER_GET_TRANSACTIONS_CLEAR: getTransactions.clear,

    UNIVERSE_SWITCH_REQUEST: universeSwitch.request,
    UNIVERSE_SWITCH_ERROR: universeSwitch.error,
    UNIVERSE_SWITCH_FINISH: universeSwitch.finish,
});
